<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMore from '../common/CheckMore.vue'

import { getModule21ImgBg } from '@/utils/modules/getStyles'

export default {
  name: 'Comp21',
  components: { ModuleTitle, CheckMore },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getModule21ImgBg }
}
</script>

<template>
  <div class="modules-id-21">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-21-content pointer">
      <div class="main-content">
        <div
          v-for="v in moduleOption.list.slice(0, 4)"
          :key="`modules-21-${v.id}`"
          class="item"
          :style="{
            background: `url(${getModule21ImgBg(path)}) no-repeat center`,
            backgroundSize: '100% 100%'
          }"
        >{{ v.headline | textLenHandler(20) }}</div>
        <check-more class="check-more-21" mode="2" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-21-content {
  height: 100%;
  display: flex;
}
.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 40px;
  .item {
    width: 442px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 17px;
    font-weight: 800;
    color: #fff;
  }
}
.check-more-21 {
  margin-top: 12px;
}
</style>
